<template>
  <div class="main">
    <div class="myHeader">
      <div class="nav">
        <img ref="imgShow" class="navImg" src="../../static/return3.png" alt="" @click="goBack()">
        <p class="main_title">图书专区</p>
        <!-- 占位作用 -->
        <p style="visibility: hidden;padding: 5px 30px 0 0;">右侧按钮</p>
      </div>
      <div class="search">
        <div class="searchLeft" @click="showPopup(1)">
          <img src="../../static/moreImg.png" alt="">
          <p>分类</p>
        </div>
        <div class="searchRight">
          <input v-model="query.name" type="text" placeholder="搜索" @keyup.enter="goSearch()">
          <img src="../../static/search.png" alt="" @click="goSearch()">
        </div>
      </div>
      <van-popup v-model="show" position="top" round :style="{ height: '60%' }">
        <div class="popupAll">
          <div class="popupHeader">
            <img src="@/static/back_black.png" alt="" @click="showPopup(2)">
            <p class="popupTitle">选择分类</p>
            <span></span>
          </div>
          <div class="popupSearch">
            <div class="Search_ipt">
              <div class="SearchBox">
                <span v-for="(item,index) in flList" :key="index" class="pushClass" @click="delItem(item,index)">{{ item.nickname }}
                  <van-icon name="cross" style="padding:0 0 0 8px;" />
                </span>
              </div>
              <span class="searchSpan" @click="showPopup(2)">取消</span>
            </div>
          </div>
          <div class="partition2"></div>
          <div class="classification">
            <p class="classification_p">分类</p>
            <div class="classification_item">
              <p v-for="(item,index) in CategoryList" :key="index" :class="{pGrey:item.checked === 0,pRed:item.checked === 1}" @click="CategoryListPush(item,index)">{{ item.nickname }}</p>
            </div>
          </div>
          <div class="popupBtn">
            <div class="popupBtn_item">
              <button class="Reset" @click="Resets()">重置</button>
              <button class="complete" @click="showPopup(3)">完成<span>(已选{{ flList.length }})</span></button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="list_box">
        <div v-for="(item,index) in list" :key="index" class="list_item" @click="bookClick(item)">
          <img :src="item.img" alt="">
          <div>
            <p class="title">{{ item.name }}</p>
            <p class="text">
              <span class="text_left">VIP:￥{{ item.vip_price }}</span>
              <span class="text_right">原价￥{{ item.price }}</span>
            </p>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import tool from '@/utils/tools'
import { Toast } from 'vant'
import { getBookList } from '@/api/book.js'
import { categorywDate } from '@/api/infohome.js'
export default {
  data() {
    return {
      show: false,
      searchMsg: '',
      flList: [],
      CategoryList: [],
      loading: false,
      finished: false,
      list: [],
      query: {
        page: 1,
        limit: 10,
        category_id: '',
        name: ''
      }
    }
  },
  mounted() {
    // this.onLoad
    this.categorywDate()
  },
  methods: {
    onLoad() {
      this.loading = true
      console.log('query.page is ' + this.query.page)
      const info = {
        page: this.query.page,
        limit: this.query.limit,
        category_id: this.query.category_id,
        name: this.query.name
      }
      getBookList(info).then(res => {
        this.loading = false
        const result = res.result ? res.result : {}
        const list = result.list ? result.list : []
        if (this.query.page === 1) {
          this.list = list
        } else {
          this.list = this.list.concat(list)
        }
        // 是否结束
        if (list.length < this.query.limit) {
          this.finished = true
          console.log('没有更多了')
        } else {
          this.finished = false
          this.query.page += 1
        }
      })
    },
    categorywDate() {
      categorywDate().then(res => {
        if (res.errNo === 0) {
          res.result.forEach((item) => {
            item.checked = 0
          })
          this.CategoryList = res.result
        }
      })
    },
    // 分类相关操作
    showPopup(type) {
      if (type === 1) {
        this.show = true
      } else if (type === 2) {
        this.show = false
      } else if (type === 3) {
        this.show = false
        this.query.page = 1
        this.list = []
        const idList = []
        this.flList.forEach((item, index) => {
          idList.push(item.fid)
        })
        if (idList && idList.length > 0) {
          this.query.category_id = idList.toString()
        } else {
          this.query.category_id = ''
        }
        this.onLoad()
      }
    },
    delItem(v, i) {
      v.checked = 0
      this.flList.splice(i, 1)
    },
    // 搜索框展示内容
    CategoryListPush(item, index) {
      if (!item.checked) {
        item.checked = 1
        this.flList.push(item)
      } else {
        item.checked = 0
        this.flList.forEach((items, i) => {
          if (items.fid === item.fid) {
            this.flList.splice(i, 1)
          }
        })
      }
    },
    // 搜索
    goSearch() {
      this.list = []
      this.loading = false
      this.query.page = 1
      this.onLoad()
    },
    // 去详情
    bookClick(item) {
      console.log(item, 'item')
      this.$router.push({
        path: 'bookInfo',
        query: {
          book_id: item.book_id
        }
      })
    },
    // 重置
    Resets() {
      this.flList = []
      this.CategoryList.forEach(item => {
        if (item.checked === 1) {
          item.checked = 0
        }
      })
    },
    goBack() {
      if (tool.isInApp()) {
        if (tool.isInIosApp()) {
          window.webkit.messageHandlers.vue_backApp.postMessage('app')
        } else {
          window.WebViewJavascriptBridge.callHandler(
            'vue_backApp',
            '返回',
            function(responseData) {

            }
          )
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main{
  background: #F6F6F6 ;
}
.myHeader {
  width: 100%;
  height: 180px;
  // background: url("../../static/topRadius.png") no-repeat;
  background: #ee2e2e;
  background-size: 100% 80%;
  position: relative;
  overflow: hidden;
  .nav {
    width: 100%;
    height: 71px;
    display: flex;
    justify-content: space-between;
    margin: 15px 0 0 0;
    .navImg {
      width: 45px;
      height: 60px;
      padding: 0px 0 0px 20px;
      position: relative;
      bottom: 3px;
    }
    .main_title {
      font-size: 36px;
      color: #fff;
      padding-left: 88px;
      letter-spacing: 2px;
      font-weight: 500;
    }
  }
  .search {
    width: 100%;
    display: flex;
    align-items: center;
    .searchLeft {
      width: 130px;
      display: flex;
      align-items: center;
      margin: 0 0 0 30px;
      p {
        font-size: 30px;
        color: #fff;
        padding: 0 0 0 12px;
      }
      img {
        width: 38px;
        height: 38px;
      }
    }
    .searchRight {
      width: 561px;
      height: 70px;
      position: relative;
      margin: 0 0 0 0px;
      img {
        width: 25px;
        height: 25px;
        position: absolute;
        left: 30px;
        top: 21px;
      }
      input {
        width: 491px;
        height: 66px;
        border-radius: 75px;
        padding: 0 0 0 70px;
        color: #777777;
        // letter-spacing: 1px;
        font-size: 24px;
        display: flex;
        align-items: center;
      }
    }
  }
}
.popupAll {
  width: 100%;
  height: 100%;
  position: relative;
  .popupHeader {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 30px 0 0 0;
    img {
      width: 68px;
      height: 68px;
      margin-left: 10px;
    }
    .popupTitle {
      font-size: 36px;
      color: #222222;
      // font-weight: 600;
      font-weight: bold;
      padding: 0 30px 0 0;
      letter-spacing: 3px;
      text-align: center;
    }
  }
  .popupSearch {
    margin: 30px 0 0 0;
    .Search_ipt {
      width: 91%;
      margin: 0 auto;
      display: flex;
      align-items: center;
      .SearchBox {
        width: 620px;
        min-height: 56px;
        border-radius: 30px;
        background: #f7f7f7;
        display: flex;
        flex-wrap: wrap;
        padding-top: 10px;
        .pushClass {
          height: 44px;
          background: #fff;
          display: inline-block;
          margin: 0 0 10px 15px;
          line-height: 44px;
          // padding: 0 13px 0 13px;
          padding: 0 13px 0 13px;
          border-radius: 10px;
          overflow: hidden;
          display: flex;
          align-items: center;
          flex-direction: row;
        }
      }
      .searchSpan {
        color: #565759;
        font-size: 24px;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        // padding: 13px 0 0 10px;
        display: inline-block;
        width: 80px;
        height: 64px;
        line-height: 64px;
        text-align: center;
      }
    }
  }
  .partition2 {
    width: 100%;
    height: 15px;
    background: #f5f5f5;
    margin: 30px 0 0 0;
  }
  .classification{
    .classification_p {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #000000;
      margin: 25px 30px;
    }
    .classification_item {
      display: flex;
      width: 93%;
      margin: 0 auto;
      flex-wrap: wrap;
      // justify-content: space-between;
      .pGrey {
        // width: 152px;
        width: 148px;
        background: #f7f7f7;
        // border-radius: 6px;
        border-radius: 10px;
        color: #666666;
        text-align: center;
        line-height: 62px;
        border: 2px solid #f7f7f7;
        margin-top: 10px;
        margin-left: 20px;
      }

      .pRed {
        width: 148px;
        // width: 152px;
        // border-radius: 6px;
        border-radius: 10px;
        background: #ffefef;
        border: 2px solid #ff7576;
        color: #ee2e2f;
        text-align: center;
        line-height: 62px;
        margin-top: 10px;
        margin-left: 20px;
      }
    }
  }
  .popupBtn {
    width: 100%;
    .popupBtn_item {
      width: 93%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      position: absolute;
      bottom: 60px;
      left: 30px;
      .Reset {
        width: 330px;
        height: 80px;
        color: #222222;
        font-size: 30px;
        letter-spacing: 2px;
        background: #f3f3f3;
        border-radius: 10px;
      }
      .complete {
        width: 330px;
        height: 80px;
        background: #ee2e2e;
        border: 1px solid #ee2e2e;
        // border-radius: 6px;
        border-radius: 10px;
        font-size: 30px;
        color: #fff;
        letter-spacing: 2px;
      }
    }
  }
}
.list_box{
  width: calc(100% - 50px);
  display: flex;
  flex-wrap: wrap;
  padding: 26px 24px 0 26px;
  justify-content: space-between;
  .list_item{
    margin-bottom: 40px;
    background: #fff;
    img{
      width: 330px;
      height: 330px;
    }
    .title{
      font-size: 28px;
      color: #333;
      margin: 22px 12px 16px;
    }
    .text{
      margin: 0 16px 10px;
      .text_left{
        color: #ee2e2e;
        margin-right: 8px;
      }
      .text_right{
        color: #666666;
      }
    }
  }
}
</style>
